export default __webpack_public_path__ + "static/media/Despoiler's Leggings of Whispered Deeds.866a8b26.jpg";